import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ExtrasBlock from './ExtrasBlock';

const MAX_SELLING_POINTS = 5;

export const getExtras = (rooms) => {
  let totalExtras = 0;

  // Iterate over each room in the jsonObject
  rooms.forEach((room) => {
    // Add the number of extras in the current room to the total
    totalExtras += room.extras.length;
  });

  if (totalExtras === 0) {
    return null;
  }
  return true;
};

const RoomExtras = (props) => {
  //Esto es para mostrar la sumarización de los extras a la derecha en el confirmation form
  const { rooms, lang, flat } = props;
  const extras = getExtras(rooms);
  if (!extras) {
    return null;
  }

  return (
    <Fragment>
      {rooms.map((room, index) => (
        <ExtrasBlock key={index} room={room} lang={lang} max={MAX_SELLING_POINTS} flat={flat}/>
      ))}
    </Fragment>
  );
};

RoomExtras.propTypes = {
  rooms: PropTypes.array.isRequired,
  lang: PropTypes.string.isRequired,
  flat: PropTypes.bool,
};

export default RoomExtras;
